export enum ModoPaginaCadastro {
  Inclusao,
  Edicao,
  /** Inclusão pré-preenchida a partir de um registro existente. */
  Duplicacao
}
export interface RespostaPadraoAPI {
  success: boolean
}

export interface RespostaPadraoDadosAPI<T> {
  success: boolean
  data: T
}

export interface RespostaPadraoPaginacaoDadosAPI<T> {
  success: boolean
  data: PaginacaoPadraoDadosAPI<T>
}
export interface PaginacaoPadraoDadosAPI<T> {
  itens: Array<T>
  quantidade: number
  temProximaPagina: boolean
}

export interface RespostaPadraoApiComErros extends RespostaPadraoAPI {
  errors: string[]
}
